/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { put, select, takeEvery } from 'redux-saga/effects'
import { getHomeSelector } from '../selectors/getHome.selector'
import { setNeedsReviewFilter } from '../store/home.actions'
import { HomeConstants } from '../store/home.constants'
import { IHomeState } from '../store/home.types'

export function* needsReviewStatusFilter() {
  const state: IHomeState = yield select(getHomeSelector)
  const { pcrDocs, filter } = state
  const { completeFilterOn, incompleteFilterOn, needsReviewFilterOn } = filter
  const filters: string[] = []
  completeFilterOn && filters.push('Complete')
  incompleteFilterOn && filters.push('Incomplete')
  const showClearFiltersButton = completeFilterOn || !needsReviewFilterOn || incompleteFilterOn
  if (needsReviewFilterOn) {
    if (filters && filters.length) {
      const filteredPCRDocs = pcrDocs.filter((pcrDoc) => filters.indexOf(pcrDoc.status) > -1)
      yield put(setNeedsReviewFilter(filteredPCRDocs, showClearFiltersButton))
    } else {
      yield put(setNeedsReviewFilter(pcrDocs, showClearFiltersButton))
    }
  } else {
    const filteredPCRDocs = state.pcrDocs.filter(
      (pcrDoc) => pcrDoc.status === 'Needs Review' || filters.indexOf(pcrDoc.status) > -1
    )
    yield put(setNeedsReviewFilter(filteredPCRDocs, showClearFiltersButton))
  }
}

export function* needsReviewStatusFilterSaga() {
  yield takeEvery([HomeConstants.FILTER_NEEDS_REVIEW], needsReviewStatusFilter)
}
